/* ===========================================================================
   LMP customer portal. Tabs + interactive US-orders / shipping / wish-list /
   customer-service. Persists to localStorage so it works today as a real,
   clickable portal. PRODUCTION HOOK: replace the load()/save() calls with
   fetch() to the LMP API (or Shopify customer metafields) so data syncs across
   devices and is visible to the LMP team. File uploads should POST to storage.
   =========================================================================== */
(function () {
  'use strict';
  var root = document.querySelector('[data-lmp-portal]');
  if (!root) return;

  // Demo mode (logged-out preview): feed every tab realistic sample data, in-memory
  // only — never persisted, so it can't pollute a real customer's saved data.
  var isDemo = root.getAttribute('data-demo') === '1';
  var DEMO = {
    'lmp-portal-info': { fullname: 'Jeffrey Cohen', email: 'jeffrey@lmpship.com', phone1: '+972 50 123 4567', phone2: '', street: '12 Rothschild Blvd', city: 'Tel Aviv', postal: '6688101', fulfilment: 'delivery' },
    'lmp-portal-orders': [
      { id: 'd1', store: 'Wayfair', fileName: 'wayfair-sofa-receipt.pdf', stage: 2, tracks: [{ id: 't1', company: 'FedEx', number: '7712 3345 8890' }] },
      { id: 'd2', store: 'Home Depot', fileName: '', stage: 1, tracks: [{ id: 't2', company: 'UPS', number: '1Z999AA10123456784' }] },
      { id: 'd3', store: 'West Elm', fileName: 'westelm-lighting.pdf', stage: 4, tracks: [{ id: 't3', company: 'USPS', number: '9400 1000 0000 1234' }] }
    ],
    'lmp-portal-wishlist': [
      { id: 'w1', url: 'https://www.wayfair.com/furniture/pdp/sectional-sofa.html', category: 'Furniture' },
      { id: 'w2', url: 'https://www.homedepot.com/p/composite-decking-boards', category: 'Building materials' },
      { id: 'w3', url: 'https://www.westelm.com/products/mid-century-pendant', category: 'Lighting & décor' }
    ]
  };
  function load(k, d) { if (isDemo && DEMO[k] != null) return JSON.parse(JSON.stringify(DEMO[k])); try { var v = JSON.parse(localStorage.getItem(k)); return v == null ? d : v; } catch (e) { return d; } }
  function save(k, v) { if (isDemo) return; try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function uid() { return 'x' + Math.random().toString(36).slice(2, 9); }
  function esc(s) { return String(s == null ? '' : s).replace(/"/g, '&quot;').replace(/</g, '&lt;'); }

  var COMPANIES = ['UPS', 'FedEx', 'USPS', 'DHL', 'Amazon', 'OnTrac', 'GLS', 'Other'];
  var STAGES = ['Received at warehouse', 'Waiting to load container', 'Sailing', 'At customs', 'Ready for pickup / delivery'];

  /* ---- tabs ---- */
  var tabs = root.querySelectorAll('[data-ptab]');
  var panels = root.querySelectorAll('[data-ppanel]');
  function activate(name) {
    tabs.forEach(function (t) { t.classList.toggle('is-active', t.dataset.ptab === name); t.setAttribute('aria-selected', t.dataset.ptab === name); });
    panels.forEach(function (p) { p.classList.toggle('is-active', p.dataset.ppanel === name); });
    if (name === 'shipping') renderShipping();
  }
  tabs.forEach(function (t) { t.addEventListener('click', function () { activate(t.dataset.ptab); }); });

  /* ---- customer information ---- */
  var infoForm = root.querySelector('[data-portal-info]');
  if (infoForm) {
    var saved = load('lmp-portal-info', null);
    if (saved) {
      ['fullname', 'email', 'phone1', 'phone2', 'street', 'city', 'postal'].forEach(function (k) { if (infoForm.elements[k]) infoForm.elements[k].value = saved[k] || ''; });
      if (saved.fulfilment) { var r = infoForm.querySelector('input[name=fulfilment][value="' + saved.fulfilment + '"]'); if (r) r.checked = true; }
    } else {
      if (infoForm.dataset.name && infoForm.elements['fullname']) infoForm.elements['fullname'].value = infoForm.dataset.name;
      if (infoForm.dataset.email && infoForm.elements['email']) infoForm.elements['email'].value = infoForm.dataset.email;
    }
    infoForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var data = {};
      ['fullname', 'email', 'phone1', 'phone2', 'street', 'city', 'postal'].forEach(function (k) { data[k] = infoForm.elements[k] ? infoForm.elements[k].value : ''; });
      var f = infoForm.querySelector('input[name=fulfilment]:checked'); data.fulfilment = f ? f.value : '';
      save('lmp-portal-info', data);
      flash(infoForm, 'Saved ✓');
    });
  }
  function flash(form, txt) { var m = form.querySelector('[data-portal-msg]'); if (m) { m.textContent = txt; setTimeout(function () { m.textContent = ''; }, 3000); } }

  /* ---- US orders ---- */
  var ordersList = root.querySelector('[data-orders-list]');
  var orders = load('lmp-portal-orders', []);
  function persistOrders() { save('lmp-portal-orders', orders); }
  function findOrder(id) { return orders.filter(function (o) { return o.id === id; })[0]; }
  function companyOptions(sel) { return COMPANIES.map(function (c) { return '<option' + (c === sel ? ' selected' : '') + '>' + c + '</option>'; }).join(''); }
  function trackLineHTML(t) {
    return '<div class="lmp-track-line" data-track="' + t.id + '">'
      + '<select data-tk="company" aria-label="Shipping company">' + companyOptions(t.company) + '</select>'
      + '<input type="text" data-tk="number" placeholder="Tracking number" value="' + esc(t.number) + '">'
      + '<button type="button" class="lmp-x" data-rm-track title="Remove tracking number">×</button></div>';
  }
  function receiptHTML(o) {
    return '<div class="lmp-receipt" data-receipt="' + o.id + '">'
      + '<div class="lmp-receipt-top">'
        + '<div class="lmp-field"><label>Store</label><input type="text" data-store placeholder="e.g. Wayfair" value="' + esc(o.store) + '"></div>'
        + '<label class="lmp-receipt-file">📎 ' + (o.fileName ? 'Receipt: ' + esc(o.fileName) : 'Upload receipt') + '<input type="file" accept="image/*,application/pdf" data-file></label>'
        + '<span data-thumb></span>'
      + '</div>'
      + '<div data-tracks>' + (o.tracks || []).map(trackLineHTML).join('') + '</div>'
      + '<button type="button" class="lmp-add-track" data-add-track><span class="lmp-plus">+</span> Add tracking number</button>'
      + '<div><button type="button" class="lmp-receipt-remove" data-rm-receipt>Remove order</button></div>'
    + '</div>';
  }
  function renderOrders() {
    if (!ordersList) return;
    ordersList.innerHTML = orders.length ? orders.map(receiptHTML).join('') : '<p class="lmp-empty">No orders yet — add your first US purchase.</p>';
  }
  var addOrderBtn = root.querySelector('[data-add-order]');
  if (addOrderBtn) addOrderBtn.addEventListener('click', function () {
    orders.push({ id: uid(), store: '', fileName: '', tracks: [{ id: uid(), company: 'UPS', number: '' }] });
    persistOrders(); renderOrders();
  });
  if (ordersList) {
    ordersList.addEventListener('click', function (e) {
      var recEl = e.target.closest('[data-receipt]'); if (!recEl) return; var o = findOrder(recEl.dataset.receipt); if (!o) return;
      if (e.target.closest('[data-add-track]')) { o.tracks.push({ id: uid(), company: 'UPS', number: '' }); persistOrders(); renderOrders(); }
      else if (e.target.closest('[data-rm-track]')) { var l = e.target.closest('[data-track]'); o.tracks = o.tracks.filter(function (t) { return t.id !== l.dataset.track; }); persistOrders(); renderOrders(); }
      else if (e.target.closest('[data-rm-receipt]')) { orders = orders.filter(function (x) { return x.id !== o.id; }); persistOrders(); renderOrders(); }
    });
    ordersList.addEventListener('input', function (e) {
      var recEl = e.target.closest('[data-receipt]'); if (!recEl) return; var o = findOrder(recEl.dataset.receipt); if (!o) return;
      if (e.target.hasAttribute('data-store')) { o.store = e.target.value; persistOrders(); }
      else if (e.target.dataset.tk) { var l = e.target.closest('[data-track]'); var t = o.tracks.filter(function (x) { return x.id === l.dataset.track; })[0]; if (t) { t[e.target.dataset.tk] = e.target.value; persistOrders(); } }
    });
    ordersList.addEventListener('change', function (e) {
      if (e.target.dataset.tk === 'company') { var recEl = e.target.closest('[data-receipt]'); var o = findOrder(recEl.dataset.receipt); var l = e.target.closest('[data-track]'); var t = o && o.tracks.filter(function (x) { return x.id === l.dataset.track; })[0]; if (t) { t.company = e.target.value; persistOrders(); } return; }
      if (!e.target.hasAttribute('data-file')) return;
      var rEl = e.target.closest('[data-receipt]'); var ord = findOrder(rEl.dataset.receipt); if (!ord) return;
      var file = e.target.files && e.target.files[0]; if (!file) return;
      ord.fileName = file.name; persistOrders();
      var lbl = rEl.querySelector('.lmp-receipt-file'); if (lbl) lbl.childNodes[0].nodeValue = '📎 Receipt: ' + file.name + ' ';
      var thumb = rEl.querySelector('[data-thumb]');
      if (thumb && /^image\//.test(file.type)) { var rd = new FileReader(); rd.onload = function () { thumb.innerHTML = '<img class="lmp-receipt-thumb" src="' + rd.result + '" alt="receipt preview">'; }; rd.readAsDataURL(file); }
    });
  }
  renderOrders();

  /* ---- shipping (read-only; stages are set by the LMP team) ---- */
  var shipList = root.querySelector('[data-ship-list]');
  function timelineHTML(stage) {
    return '<div class="lmp-timeline">' + STAGES.map(function (s, i) {
      var cls = i < stage ? 'is-done' : (i === stage ? 'is-current' : '');
      return '<div class="lmp-tl-step ' + cls + '"><div class="lmp-tl-dot">' + (i < stage ? '✓' : (i + 1)) + '</div><div class="lmp-tl-label">' + s + '</div></div>';
    }).join('') + '</div>';
  }
  function renderShipping() {
    if (!shipList) return;
    var html;
    if (orders.length) {
      html = orders.map(function (o, i) {
        var stage = o.stage || 0;
        return '<div class="lmp-ship"><div class="lmp-ship-head"><strong>' + (esc(o.store) || ('Order ' + (i + 1))) + '</strong><span class="lmp-ship-stage-tag">' + STAGES[stage] + '</span></div>' + timelineHTML(stage) + '</div>';
      }).join('');
    } else {
      // No real data yet — show the empty stage timeline (nothing highlighted).
      html = '<div class="lmp-ship"><div class="lmp-ship-head"><strong>Your shipment</strong></div>'
        + timelineHTML(-1)
        + '<p class="lmp-empty">No shipment yet. The stages above light up as our team receives and moves your goods.</p></div>';
    }
    shipList.innerHTML = html;
  }

  /* ---- wish list ---- */
  var wishList = root.querySelector('[data-wish-list]');
  var wishForm = root.querySelector('[data-wish-form]');
  var wish = load('lmp-portal-wishlist', []);
  function domainOf(u) { try { return new URL(u).hostname.replace(/^www\./, ''); } catch (e) { return (String(u).split('/')[2] || '').replace(/^www\./, ''); } }
  function renderWish() {
    if (!wishList) return;
    if (!wish.length) { wishList.innerHTML = '<p class="lmp-empty">No wish-list items yet — paste a product link and pick a category.</p>'; return; }
    var groups = {};
    wish.forEach(function (w) { (groups[w.category] = groups[w.category] || []).push(w); });
    wishList.innerHTML = Object.keys(groups).map(function (cat) {
      return '<div class="lmp-wish-group"><h4>' + esc(cat) + '</h4>'
        + '<div class="lmp-wish-head"><span>Product</span><span>Website</span><span>Link</span><span></span></div>'
        + groups[cat].map(function (w) {
          var dom = domainOf(w.url);
          var thumb = 'https://api.microlink.io/?url=' + encodeURIComponent(w.url) + '&embed=image.url';
          var fav = 'https://icons.duckduckgo.com/ip3/' + esc(dom) + '.ico';
          return '<div class="lmp-wish-item">'
            + '<img class="lmp-wish-thumb" src="' + thumb + '" alt="" loading="lazy" referrerpolicy="no-referrer" onerror="this.onerror=null;this.src=\'' + fav + '\';this.classList.add(\'is-fallback\')">'
            + '<span class="lmp-wish-site">' + esc(dom) + '</span>'
            + '<a class="lmp-wish-link" href="' + esc(w.url) + '" target="_blank" rel="noopener nofollow" title="' + esc(w.url) + '">' + esc(w.url) + '</a>'
            + '<button type="button" class="lmp-x" data-rm-wish="' + w.id + '" title="Remove">×</button>'
            + '</div>';
        }).join('') + '</div>';
    }).join('');
  }
  if (wishForm) wishForm.addEventListener('submit', function (e) {
    e.preventDefault();
    var url = wishForm.elements['url'].value.trim(); if (!url) return;
    if (!/^https?:\/\//i.test(url)) url = 'https://' + url;
    wish.push({ id: uid(), url: url, category: wishForm.elements['category'].value });
    save('lmp-portal-wishlist', wish); renderWish(); wishForm.reset();
  });
  if (wishList) wishList.addEventListener('click', function (e) { var b = e.target.closest('[data-rm-wish]'); if (!b) return; wish = wish.filter(function (w) { return w.id !== b.dataset.rmWish; }); save('lmp-portal-wishlist', wish); renderWish(); });
  renderWish();

  /* ---- customer service ---- */
  var ticketForm = root.querySelector('[data-ticket-form]');
  if (ticketForm) ticketForm.addEventListener('submit', function (e) {
    e.preventDefault();
    var subject = ticketForm.elements['subject'].value.trim(); var body = ticketForm.elements['message'].value.trim();
    var tickets = load('lmp-portal-tickets', []); tickets.push({ id: uid(), subject: subject, body: body, ts: Date.now() }); save('lmp-portal-tickets', tickets);
    flash(ticketForm, 'Ticket opened ✓ — opening your email app…');
    window.location.href = 'mailto:hello@lmpship.com?subject=' + encodeURIComponent('[Support] ' + subject) + '&body=' + encodeURIComponent(body);
    ticketForm.reset();
  });
  var chatBtn = root.querySelector('[data-open-chat]');
  if (chatBtn) chatBtn.addEventListener('click', function () { var fab = document.querySelector('[data-lmp-chat-fab]'); if (fab) fab.click(); else window.location.href = 'mailto:hello@lmpship.com'; });
})();
